import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function LatestSection() {
  const latest = [...comics]
    .sort((a, b) => new Date(b.chapters[0].updatedAt).getTime() - new Date(a.chapters[0].updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="py-8 md:py-10" aria-labelledby="latest-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <h2 id="latest-title" className="text-lg md:text-xl font-heading text-foreground-900">
            最近更新
          </h2>
          <Link to="/category/shaonian" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
            更多更新 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {latest.map((comic) => {
            const cat = categories.find((c) => c.slug === comic.category);
            return (
              <ComicCard
                key={comic.id}
                slug={comic.slug}
                title={comic.title}
                author={comic.author}
                cover={comic.cover}
                category={comic.category}
                categoryName={cat?.name || ''}
                status={comic.status}
                rating={comic.rating}
                views={comic.views}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}